import React from 'react';

import classNames from 'classnames';

import './index.scss';

const Navbar = ({ component: Component = 'nav', ...props }) => (
  <Component {...props} className={classNames('navbar', props.className)}>
    {props.children}
  </Component>
);

export default Navbar;
